var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"attachments"},_vm._l((_vm.files),function(file){return _c('Attachment',{key:file.id,attrs:{"file":file,"show-detail":_vm.showDetail}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }